import { MapUiTheme } from '../../common';

export const linkTheme = {
  defaultStyles: {
    fontSize: (theme: MapUiTheme) => theme.fontSize.sm,
    fontWeight: (theme: MapUiTheme) => theme.fontWeight.normal,
    cursor: 'pointer',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: (theme: MapUiTheme) => theme.lineHeight.normal,
    color: (theme: MapUiTheme) => theme.colors.interaction200,
    textDecoration: 'underline',
    backgroundColor: 'initial',
  },
};
